import { render, staticRenderFns } from "./ListOTIndex.vue?vue&type=template&id=808978d6&scoped=true&lang=pug"
import script from "./ListOTIndex.vue?vue&type=script&lang=js"
export * from "./ListOTIndex.vue?vue&type=script&lang=js"
import style0 from "./ListOTIndex.vue?vue&type=style&index=0&id=808978d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808978d6",
  null
  
)

export default component.exports